import http from "../helpers/http-common"

class MailService {

    sendMail(params) {
        return http.post(`/mail/send`, params);
    }

    generateMessage(params) {
        return http.post(`/mail/generate`, params);
    }

    deleteGenerateMessage(params) {
        return http.post(`/mail/delete`, params);
    }
}

export default new MailService();